export default {
  themes: {
    apple_green: '苹果绿',
    emerald_green: '翡翠绿',
    green: '绿色',
    blue: '蓝色',
    brown: '棕色',
    indigo: '靛色',
    purple: '紫色'
  }
}
